import styled from 'styled-components';

interface Props {
  inputIcon?: string;
}

export const Container = styled.div<Props>`
  &.icon-input {
    width: 100%;
  }

  .icon-input__wrapper {
    display: flex;
    align-items: center;
    gap: 10px;

    width: 100%;
    height: 55px;

    padding: 15px 20px;

    border-radius: 28px;
    border: 1px solid transparent;

    background: #fff;
  }

  .icon-input__icon {
    width: 24px;
    height: 24px;

    background: no-repeat center;
    background-size: contain;
    background-image: ${({ inputIcon }) => inputIcon && `url(${inputIcon})`};
  }

  .icon-input__input {
    width: 90%;
    border: 0;

    font-size: 1rem;
    color: var(--blue12);

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: var(--graycd);
    }
  }
`;
